module.exports = __webpack_public_path__ + "img/home-blue.5709037e.png";